import React, { createContext, useState, useContext, useEffect } from "react";

const ProjectIdContext = createContext();

export const ProjectIdProvider = ({ children }) => {
  const [projectId, setProjectId] = useState(null);

  // Sync projectId with localStorage on mount
  useEffect(() => {
    const savedProjectId = localStorage.getItem("projectId");
    if (savedProjectId) {
      setProjectId(savedProjectId);
    }
  }, []);

  // Update localStorage whenever projectId changes
  useEffect(() => {
    if (projectId) {
      localStorage.setItem("projectId", projectId);
    }
  }, [projectId]);

  return (
    <ProjectIdContext.Provider value={{ projectId, setProjectId }}>
      {children}
    </ProjectIdContext.Provider>
  );
};

export const useProjectId = () => {
  return useContext(ProjectIdContext);
};
